export const OPEN_ORDERS_DIALOG_EVENT = "orders:open";

export const emitOpenOrdersDialog = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(OPEN_ORDERS_DIALOG_EVENT));
};


